export default __webpack_public_path__ + "static/american-flag-small-aa87d9049c6862c232df52e82735acc3.png";